<div class="container-fluid d-flex flex-column hcm-custom-screen-profile">
    <nav aria-label="breadcrumb" class="d-none d-md-block">
        <ol class="breadcrumb">
            <li class="breadcrumb-item hcm-breadcrumb-text">
                <a routerLink="/home">HOME</a>
            </li>
            <li class="breadcrumb-item active hcm-breadcrumb-text" aria-current="page">
                PROFILE INFORMATION
            </li>
        </ol>

    </nav>
    <h4 class="d-sm-none hcm-header-align" (click)="navigateToHome()"> 
       <img src="../../../../assets/img/navigation_black.svg" alt="back" class="me-2">
        <span class="hcm-header">{{ 'profile.userProfile' | translate }}</span>
    </h4>
    <mat-card appearance="outlined">
            <div class="row user-info-align">
                <div class="hcm-acc-header mb-3">{{
                    'profile.personalInfo.title' | translate }}</div>
                <div class="col-md-3 col-6">
                    <p class="hcm-label">{{
                        'profile.personalInfo.fullName' | translate }}<br><span
                            class="hcm-value">{{userDetails?.name}}</span></p>
                </div>
                <div class="col-md-3 col-6">
                    <p class="hcm-label">{{
                        'profile.personalInfo.email' | translate }}<br><span
                            class="hcm-value">{{userDetails?.preferred_username}}</span></p>
                </div>
                <div class="col-md-2 col-6">
                    <p class="hcm-label">{{
                        'profile.personalInfo.telephone' | translate }}<br><span
                            class="hcm-value"></span></p>
                </div>
                <div class="hcm-acc-header mb-3 d-flex justify-content-between justify-content-md-start">{{
                    'profile.professionalInfo.title' | translate }}
                    <span class="cu ms-2 ms-md-4" (click)="navigateToEditProfile()">
                        <img class="mb-1" src="../../../../assets/img/pencil_black.svg" alt="Edit"/>
                        <small
                            class="hcm-value ms-1 text-decoration-underline">Edit</small>
                    </span>
                </div>

                <div class="col-md-2 col-6">
                    <p class="hcm-label">{{
                        'profile.professionalInfo.jobTitle' | translate }}<br><span
                            class="hcm-value"></span>
                    </p>
                </div>
                <div class="col-md-2 col-6">
                    <p class="hcm-label">{{
                        'profile.professionalInfo.role' | translate }}<br><span
                            class="hcm-value">{{role}}</span>
                    </p>
                </div>
                <div class="col-md-2 col-6">
                    <p class="hcm-label">{{ 'profile.namc' | translate
                        }}<br><span class="hcm-value">{{namc}}</span></p>
                </div>
                <div class="col-md-2 col-6">
                    <p class="hcm-label">{{ 'PLANT' | translate
                        }}<br><span class="hcm-value">{{user?.plant}}</span>
                    </p>
                </div>
                <div class="col-md-2 col-6">
                    <p class="hcm-label">{{ 'SHOP' | translate
                        }}<br><span class="hcm-value">{{user?.shop}}</span></p>
                </div>
                <div class="col-12">
                    <p class="hcm-label">{{ 'LINE_NAME' | translate
                        }}<br><span class="hcm-value">{{user?.line}}</span></p>
                </div> 
            </div>
    </mat-card>
</div>
<!-- back button  -->
<mat-toolbar class="mt-auto">
    <mat-toolbar-row class="footer-blue">
        <button class="hcm-back-btn"
            (click)="navigateToHome()">
            <img src="../../../../assets/img/navigation_blue.svg" alt="back" class="me-1 mb-1">
            {{ 'vehicleInfo.buttons.back' | translate }}
        </button>
    </mat-toolbar-row>
</mat-toolbar>
